module.exports = "<uch></uch>\r\n<head-title params='title:\"应用列表 / 授权列表 / 委托列表\"'></head-title>\r\n<div class=\"userContBottom\">\r\n    <div class=\"userContent\">\r\n       <manage-auth></manage-auth>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/component/appConfig/template/manageAuthIndex.html
// module id = 223
// module chunks = 0